var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('main',{class:!_vm.showTest ? 'container' : 'container-new'},[(_vm.showTest === null)?_c('div',[_vm._v("LOADING...")]):_vm._e(),(!_vm.showTest)?_c('ShortSummaryControl',{attrs:{"data-testid":"short-summary-control"}}):(_vm.showTest)?_c('ShortSummaryTest',{attrs:{"data-testid":"short-summary-test"}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }